import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { NewEmailForm } from "../../-components/NewEmailForm";
import type { EmailType, EmailLanguage } from "@/lib/mma/types.gen";
import { ContextUser } from "@/lib/utils";

export const Route = createFileRoute("/_dashboard/emails/organisations/$orgId/new-email")({
  component: NewEmailComponent,
  validateSearch: (search: Record<string, unknown>) => {
    const type = search.type ? (search.type as EmailType) : undefined;
    const language = search.language ? (search.language as EmailLanguage) : undefined;
    return { type, language };
  },
  loader: async ({ context }) => ({ user: context.user as ContextUser | null | undefined }),
});

function NewEmailComponent() {
  const { orgId } = Route.useParams();
  const { user } = Route.useLoaderData();
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate({
      to: "/emails/organisations/$orgId",
      params: { orgId },
      search: { type: undefined, language: undefined },
    });
  };

  return (
    <NewEmailForm
      scope="organisation"
      orgId={orgId}
      user={user}
      returnTo={`/emails/organisations/${orgId}`}
      onCancel={handleCancel}
    />
  );
}
